"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoneMetricsSdkByType = exports.MetricsByType = exports.ZoneMetric = exports.ZoneMetricType = void 0;
var ZoneMetricType;
(function (ZoneMetricType) {
    ZoneMetricType["Attractiveness"] = "attractiveness";
    ZoneMetricType["Roi"] = "roi";
    ZoneMetricType["Performance"] = "performance";
    ZoneMetricType["Interaction"] = "interaction";
})(ZoneMetricType = exports.ZoneMetricType || (exports.ZoneMetricType = {}));
var ZoneMetric;
(function (ZoneMetric) {
    ZoneMetric["sessionsWithClick"] = "sessionsWithClick";
    ZoneMetric["sessionsWithHover"] = "sessionsWithHover";
    ZoneMetric["viewWithClick"] = "viewWithClick";
    ZoneMetric["viewWithHover"] = "viewWithHover";
    ZoneMetric["timeBeforeFirstClick"] = "timeBeforeFirstClick";
    ZoneMetric["hesitation"] = "hesitation";
    ZoneMetric["totalClicks"] = "totalClicks";
    ZoneMetric["totalHovers"] = "totalHovers";
    ZoneMetric["totalRevenueAfterClick"] = "totalRevenueAfterClick";
    ZoneMetric["conversionAfterClick"] = "conversionAfterClick";
    ZoneMetric["averageRevenueAfterClick"] = "averageRevenueAfterClick";
    ZoneMetric["transactionCountWithClick"] = "transactionCountWithClick";
    ZoneMetric["transactionCountWithHover"] = "transactionCountWithHover";
    ZoneMetric["totalConversionAfterClick"] = "totalConversionAfterClick";
    ZoneMetric["totalConversionAfterHover"] = "totalConversionAfterHover";
    ZoneMetric["totalHoverTime"] = "totalHoverTime";
    ZoneMetric["avgConversionAfterClick"] = "avgConversionAfterClick";
    ZoneMetric["avgConversionAfterHover"] = "avgConversionAfterHover";
    ZoneMetric["avgTransactionAfterClick"] = "avgTransactionAfterClick";
    ZoneMetric["avgTransactionAfterHover"] = "avgTransactionAfterHover";
    ZoneMetric["avgHoverTime"] = "avgHoverTime";
    ZoneMetric["engagementRateLive"] = "engagementRateLive";
    ZoneMetric["clickRepetition"] = "clickRepetition";
    ZoneMetric["clickRate"] = "clickRate";
    ZoneMetric["hoverRate"] = "hoverRate";
    ZoneMetric["attractivenessRate"] = "attractivenessRate";
    ZoneMetric["exposureRate"] = "exposureRate";
    ZoneMetric["exposureTime"] = "exposureTime";
    ZoneMetric["engagementRate"] = "engagementRate";
    ZoneMetric["conversionAfterHover"] = "conversionAfterHover";
    ZoneMetric["hoverTime"] = "hoverTime";
    ZoneMetric["tapRate"] = "tapRate";
    ZoneMetric["conversionAfterTap"] = "conversionRatePerTap";
    ZoneMetric["flickRate"] = "flickRate";
    ZoneMetric["dragRate"] = "dragRate";
    ZoneMetric["dragFlickRate"] = "dragFlickRate";
    ZoneMetric["tapRecurrence"] = "tapRecurrence";
    ZoneMetric["flickRecurrence"] = "flickRecurrence";
    ZoneMetric["dragRecurrence"] = "dragRecurrence";
    ZoneMetric["dragFlickRecurrence"] = "dragFlickRecurrence";
    ZoneMetric["tapCount"] = "tapCount";
    ZoneMetric["timeBeforeFirstTap"] = "timeBeforeFirstTap";
    ZoneMetric["averageRevenueAfterTap"] = "revenuePerTap";
    ZoneMetric["totalRevenueAfterTap"] = "totalRevenueWithTap";
})(ZoneMetric = exports.ZoneMetric || (exports.ZoneMetric = {}));
exports.MetricsByType = {
    attractiveness: [ZoneMetric.clickRate, ZoneMetric.timeBeforeFirstClick],
    roi: [
        ZoneMetric.totalRevenueAfterClick,
        ZoneMetric.averageRevenueAfterClick,
        ZoneMetric.avgTransactionAfterClick,
        ZoneMetric.avgTransactionAfterHover,
    ],
    performance: [ZoneMetric.conversionAfterClick, ZoneMetric.conversionAfterHover],
    interaction: [
        ZoneMetric.hoverRate,
        ZoneMetric.engagementRateLive,
        ZoneMetric.hesitation,
        ZoneMetric.hoverTime,
        ZoneMetric.clickRepetition,
        ZoneMetric.exposureRate,
        ZoneMetric.exposureTime,
        ZoneMetric.attractivenessRate,
    ],
};
exports.ZoneMetricsSdkByType = {
    attractiveness: [ZoneMetric.tapRate, ZoneMetric.tapCount, ZoneMetric.timeBeforeFirstTap],
    roi: [ZoneMetric.totalRevenueAfterTap, ZoneMetric.averageRevenueAfterTap, ZoneMetric.conversionAfterTap],
    performance: [ZoneMetric.conversionAfterTap],
    interaction: [
        ZoneMetric.tapRecurrence,
        ZoneMetric.dragFlickRate,
        ZoneMetric.dragFlickRecurrence,
        ZoneMetric.flickRate,
        ZoneMetric.dragRate,
    ],
};
//# sourceMappingURL=zoning.metrics.request.model.js.map